import React, { Component } from "react";
import "./changeAdminStatusModal.css";
import { updateAdminStatusRedux } from "../../actions/index";
import { connect } from "react-redux";
import { roleTone } from "./AdminBadge";

class ChangeAdminStatusModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: this.props.adminObj?.status || "",
      activeStatus: this.props.adminObj?.activeStatus || "",
      saving: false,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.adminObj?.adminId !== this.props.adminObj?.adminId) {
      this.setState({
        status: nextProps.adminObj?.status || "",
        activeStatus: nextProps.adminObj?.activeStatus || "",
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    let { adminObj } = this.props;
    const { status } = this.state;

    this.setState({ saving: true });
    try {
      await this.props.updateAdminStatusRedux({
        ...adminObj,
        status: status,
        activeStatus: this.state.activeStatus,
      });
    } finally {
      this.setState({ saving: false });
    }

    this.props.startToggleModal(null);
    this.setState({
      status: "",
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  close = () => this.props.startToggleModal(null);

  render() {
    const { toggleModal, adminObj } = this.props;
    const { status, activeStatus, saving } = this.state;
    const name = adminObj?.name || "this admin";

    return (
      <div
        className={"modal tb-modal kd-admin-modal" + (toggleModal ? "" : " show visible-modal")}
        id="request_popup"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="kd-admin-modal-title"
        aria-hidden={toggleModal}
        onClick={(e) => e.target === e.currentTarget && this.close()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <form className="modal-content" onSubmit={this.handleSubmit}>
            <div className="modal-header">
              <div className="modal-title" id="kd-admin-modal-title">
                Update admin status
              </div>
              <button type="button" className="close" aria-label="Close" onClick={this.close}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="kd-admin-modal-body">
                <p className="kd-admin-modal-who">
                  Changing the role and access for <strong>{name}</strong>.
                </p>

                <div className="form-group">
                  <label htmlFor="kd-admin-role">Role</label>
                  <select
                    id="kd-admin-role"
                    required
                    name="status"
                    className="custom-select"
                    onChange={this.handleChange}
                    value={status}
                  >
                    <option value="">Select role</option>
                    <option value="Admin">Admin</option>
                    <option value="Accounts">Accounts</option>
                    <option value="Employee">Employee</option>
                    <option value="Officer">Officer</option>
                  </select>
                </div>

                <fieldset className="kd-admin-access">
                  <legend>Access</legend>
                  {[
                    ["Active", "mint", "Can sign in to the admin panel"],
                    ["Inactive", "rose", "Can't sign in"],
                  ].map(([value, tone, hint]) => (
                    <label
                      key={value}
                      className={`kd-admin-access-opt kd-st--${tone}` + (activeStatus === value ? " is-on" : "")}
                    >
                      <input
                        type="radio"
                        name="activeStatus"
                        value={value}
                        required
                        checked={activeStatus === value}
                        onChange={this.handleChange}
                      />
                      <span className="kd-status-dot" aria-hidden="true" />
                      <span>
                        <strong>{value}</strong>
                        <small>{hint}</small>
                      </span>
                    </label>
                  ))}
                </fieldset>

                {status && (
                  <p className="kd-admin-modal-sum">
                    <span className={`kd-status-badge kd-st--${roleTone(status)}`}>{status}</span>
                    {activeStatus && (
                      <span className={`kd-status-badge kd-st--${activeStatus === "Active" ? "mint" : "rose"}`}>
                        <span className="kd-status-dot" />
                        {activeStatus}
                      </span>
                    )}
                  </p>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-light" onClick={this.close}>
                Cancel
              </button>
              <button type="submit" className="btn" disabled={saving}>
                {saving ? "Updating…" : "Update status"}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(null, { updateAdminStatusRedux })(
  ChangeAdminStatusModal
);
